import { render, staticRenderFns } from "./ProposalTemplateForm.vue?vue&type=template&id=c876c592"
import script from "./ProposalTemplateForm.vue?vue&type=script&lang=js"
export * from "./ProposalTemplateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports